// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormVerify_wrapper__24Nb9","fixed":"FormVerify_fixed__2S5dH","label":"FormVerify_label__3DAh-","value":"FormVerify_value__1emxm"};